import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const IModelService = ( createDecorator('modelService'));
export { IModelService };
